// src/apply-applicantTaskConfig.ts
import { SectionLabel, SectionRoute, YourInformationTaskGroupLabel, ApplicationTaskGroupLabel, YourInformationTaskLabel, ApplicationTaskLabel, YourInformationTaskRoute, ApplicationTaskRoute, OfferTaskLabel, OfferTaskRoute, OfferTaskGroupLabel, ApplicationStatus } from "platform-types";
var applicantTasksConfig = {
  defaultTask: {
    label: SectionLabel.Home,
    route: SectionRoute.Home
  },
  sections: [
    {
      label: SectionLabel.YourInformation,
      route: SectionRoute.YourInformation,
      taskGroups: [
        {
          label: YourInformationTaskGroupLabel.AboutYou,
          tasks: [
            {
              label: YourInformationTaskLabel.ContactDetails,
              route: YourInformationTaskRoute.ContactDetails
            },
            {
              label: YourInformationTaskLabel.FeeStatus,
              route: YourInformationTaskRoute.FeeStatus
            },
            {
              label: YourInformationTaskLabel.ProgrammeChoices,
              route: YourInformationTaskRoute.ProgrammeChoices
            }
          ]
        },
        {
          label: YourInformationTaskGroupLabel.YourQualifications,
          tasks: [
            {
              label: YourInformationTaskLabel.HighestStudy,
              route: YourInformationTaskRoute.HighestStudy
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Application,
      route: SectionRoute.Application,
      taskGroups: [
        {
          label: ApplicationTaskGroupLabel.PersonalInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.Identity,
              route: ApplicationTaskRoute.Identity
            },
            {
              label: ApplicationTaskLabel.NationalityResidence,
              route: ApplicationTaskRoute.NationalityResidence
            },
            {
              label: ApplicationTaskLabel.ContactDetails,
              route: ApplicationTaskRoute.ContactDetails
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.QualificationsExperience,
          tasks: [
            {
              label: ApplicationTaskLabel.EducationHistory,
              route: ApplicationTaskRoute.EducationHistory
            },
            {
              label: ApplicationTaskLabel.EnglishLanguage,
              route: ApplicationTaskRoute.EnglishLanguage
            },
            {
              label: ApplicationTaskLabel.Employment,
              route: ApplicationTaskRoute.Employment
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.SupportingInformation,
          tasks: [
            {
              label: ApplicationTaskLabel.References,
              route: ApplicationTaskRoute.References
            },
            {
              label: ApplicationTaskLabel.PersonalStatement,
              route: ApplicationTaskRoute.PersonalStatement
            },
            {
              label: ApplicationTaskLabel.ResearchProposal,
              route: ApplicationTaskRoute.ResearchProposal
            },
            {
              label: ApplicationTaskLabel.Funding,
              route: ApplicationTaskRoute.Funding
            },
            {
              label: ApplicationTaskLabel.ImmigrationHistory,
              route: ApplicationTaskRoute.ImmigrationHistory
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.AboutYourApplication,
          tasks: [
            {
              label: ApplicationTaskLabel.DiversityInclusion,
              route: ApplicationTaskRoute.DiversityInclusion
            },
            {
              label: ApplicationTaskLabel.Representation,
              route: ApplicationTaskRoute.Representation
            },
            {
              label: ApplicationTaskLabel.Referral,
              route: ApplicationTaskRoute.Referral
            },
            {
              label: ApplicationTaskLabel.Declarations,
              route: ApplicationTaskRoute.Declarations
            }
          ]
        },
        {
          label: ApplicationTaskGroupLabel.Consent,
          tasks: [
            {
              label: ApplicationTaskLabel.InformationProcessing,
              route: ApplicationTaskRoute.InformationProcessing
            },
            {
              label: ApplicationTaskLabel.PrivacyPolicy,
              route: ApplicationTaskRoute.PrivacyPolicy
            },
            {
              label: ApplicationTaskLabel.TermsConditions,
              route: ApplicationTaskRoute.TermsConditions
            },
            {
              label: ApplicationTaskLabel.AccuracyOfData,
              route: ApplicationTaskRoute.AccuracyOfData
            }
          ]
        }
      ]
    },
    {
      label: SectionLabel.Programmes,
      route: SectionRoute.Programmes,
      taskGroups: [
        {
          label: OfferTaskGroupLabel.Acceptance,
          tasks: [
            {
              label: OfferTaskLabel.ConditionalOffer,
              route: OfferTaskRoute.ConditionalOffer
            },
            {
              label: OfferTaskLabel.UnconditionalOffer,
              route: OfferTaskRoute.UnconditionalOffer
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Conditions,
          tasks: [
            {
              label: OfferTaskLabel.Passport,
              route: OfferTaskRoute.Passport
            },
            {
              label: OfferTaskLabel.PhotoID,
              route: OfferTaskRoute.PhotoID
            },
            {
              label: OfferTaskLabel.ProofOfNameChange,
              route: OfferTaskRoute.ProofOfNameChange
            },
            {
              label: OfferTaskLabel.NameAffidavit,
              route: OfferTaskRoute.NameAffidavit
            },
            {
              label: OfferTaskLabel.BirthCert,
              route: OfferTaskRoute.BirthCert
            },
            {
              label: OfferTaskLabel.AcademicResults,
              route: OfferTaskRoute.AcademicResults
            },
            {
              label: OfferTaskLabel.FinalAcademicResults,
              route: OfferTaskRoute.FinalAcademicResults
            },
            {
              label: OfferTaskLabel.AcademicCertificate,
              route: OfferTaskRoute.AcademicCertificate
            },
            {
              label: OfferTaskLabel.AcademicTranscript,
              route: OfferTaskRoute.AcademicTranscript
            },
            {
              label: OfferTaskLabel.EnglishLanguageResults,
              route: OfferTaskRoute.EnglishLanguageResults
            },
            {
              label: OfferTaskLabel.EnglishLanguageCertificate,
              route: OfferTaskRoute.EnglishLanguageCertificate
            },
            {
              label: OfferTaskLabel.ProofOfManagerialExperience,
              route: OfferTaskRoute.ProofOfManagerialExperience
            },
            {
              label: OfferTaskLabel.ProofOfAddress,
              route: OfferTaskRoute.ProofOfAddress
            },
            {
              label: OfferTaskLabel.CV,
              route: OfferTaskRoute.CV
            },
            {
              label: OfferTaskLabel.ProofOfImmigrationStatus,
              route: OfferTaskRoute.ProofOfImmigrationStatus
            },
            {
              label: OfferTaskLabel.LetterOfRecommendation,
              route: OfferTaskRoute.LetterOfRecommendation
            },
            {
              label: OfferTaskLabel.PersonalStatement,
              route: OfferTaskRoute.PersonalStatement
            },
            {
              label: OfferTaskLabel.RefereeDetails,
              route: OfferTaskRoute.RefereeDetails
            },
            {
              label: OfferTaskLabel.Custom,
              route: OfferTaskRoute.Custom
            }
          ]
        },
        {
          label: OfferTaskGroupLabel.Finance,
          tasks: [
            {
              label: OfferTaskLabel.Payment,
              route: OfferTaskRoute.Payment
            },
            {
              label: OfferTaskLabel.ProofOfPayment,
              route: OfferTaskRoute.ProofOfPayment
            }
          ]
        }
      ]
    }
  ]
};
var uniViewApplicantTaskGroups = applicantTasksConfig.sections[1].taskGroups.map((taskGroup) => {
  const { label, tasks } = taskGroup;
  return {
    label,
    tasks: tasks.map((task) => {
      const { label: taskLabel, route } = task;
      return {
        label: taskLabel,
        route: route.replace("/applications/{applicationId}", "").replace("applications/{applicationId}", "")
        // more robust
      };
    })
  };
});
var ActiveApplicationStatues = [
  ApplicationStatus.InProgress,
  ApplicationStatus.Completed,
  ApplicationStatus.Submitted
];

// src/apply-months.ts
var MONTHS = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" }
];

// src/apply-offers.ts
import { ApplicantOfferStatus, ApplicantStatusReason } from "platform-types";
var offerIssueStatuses = [ApplicantOfferStatus.Conditional, ApplicantOfferStatus.Unconditional];
var offerNeedsReissueStatuses = [...offerIssueStatuses, ApplicantOfferStatus.Withdrawn];
var userGeneratedApplicantStatusReasonLabels = {
  [ApplicantStatusReason.EntryCriteriaNotMet]: "Entry criteria not met",
  [ApplicantStatusReason.FailedAcademicAssessment]: "Failed academic assessment",
  [ApplicantStatusReason.FailedCredibilityAssessment]: "Failed credibility assessment",
  [ApplicantStatusReason.FraudulentApplication]: "Fraudulent application",
  [ApplicantStatusReason.CourseClosure]: "Course closure",
  [ApplicantStatusReason.CourseFull]: "Course full",
  [ApplicantStatusReason.UnableToOfferCourse]: "Unable to offer course to applicant",
  [ApplicantStatusReason.DeadlineHasPassed]: "Deadline has passed",
  [ApplicantStatusReason.ClosedByApplicant]: "Closed by applicant",
  [ApplicantStatusReason.WrongApplicationForm]: "Wrong application form",
  [ApplicantStatusReason.FailedPreCasInterview]: "Failed Pre-CAS Interview",
  [ApplicantStatusReason.FailedComplianceInterview]: "Failed Compliance Interview",
  [ApplicantStatusReason.NegativeQualificationVerification]: "Negative Qualification Verification",
  [ApplicantStatusReason.DuplicateApplication]: "Duplicate application",
  [ApplicantStatusReason.InactiveApplication]: "Inactive application",
  [ApplicantStatusReason.RegionExclusiveToAgent]: "The region is exclusive to a specific agent",
  [ApplicantStatusReason.Other]: "Other"
};
var systemGeneratedApplicantStatusReasonLabels = {
  [ApplicantStatusReason.AcceptedByApplicant]: "Accepted by applicant",
  [ApplicantStatusReason.CompletedByApplicant]: "Completed by applicant",
  [ApplicantStatusReason.WithdrawnOnCompletion]: "Closed by applicant"
};
var statusReasonOptions = [
  { label: "Entry criteria not met", value: ApplicantStatusReason.EntryCriteriaNotMet },
  { label: "Failed academic assessment", value: ApplicantStatusReason.FailedAcademicAssessment },
  { label: "Failed credibility assessment", value: ApplicantStatusReason.FailedCredibilityAssessment },
  { label: "Fraudulent application", value: ApplicantStatusReason.FraudulentApplication },
  { label: "Course closure", value: ApplicantStatusReason.CourseClosure },
  { label: "Course full", value: ApplicantStatusReason.CourseFull },
  { label: "Unable to offer course to applicant", value: ApplicantStatusReason.UnableToOfferCourse },
  { label: "Deadline has passed", value: ApplicantStatusReason.DeadlineHasPassed },
  { label: "Closed by applicant", value: ApplicantStatusReason.ClosedByApplicant },
  { label: "Wrong application form", value: ApplicantStatusReason.WrongApplicationForm },
  { label: "Failed Pre-CAS Interview", value: ApplicantStatusReason.FailedPreCasInterview },
  { label: "Failed Compliance Interview", value: ApplicantStatusReason.FailedComplianceInterview },
  { label: "Negative Qualification Verification", value: ApplicantStatusReason.NegativeQualificationVerification },
  { label: "Duplicate application", value: ApplicantStatusReason.DuplicateApplication },
  { label: "Inactive application", value: ApplicantStatusReason.InactiveApplication },
  { label: "The region is exclusive to a specific agent", value: ApplicantStatusReason.RegionExclusiveToAgent },
  { label: "Other", value: ApplicantStatusReason.Other }
];
var OfferTooltipLabels = {
  applicantAccepted: "The applicant has accepted this offer",
  applicantDeclined: "Applicant has declined this offer",
  offerWithdrawn: "Offer withdrawn",
  pendingChanges: "Offer edited since it was last issued",
  pendingChangesByApplicant: "Applicant has provided new information",
  newDocumentsCount: (count) => {
    if (count === 1) {
      return `${count} new update from applicant`;
    }
    return `${count} new updates from applicant`;
  },
  requirementsNotSatisfied: (count) => {
    if (count === 1) {
      return `Offer cannot be issued as ${count} requirement is not satisfied`;
    }
    return `Offer cannot be issued as ${count} requirements are not satisfied`;
  }
};

// src/apply-config-applyUniConfig.ts
function deepFreeze(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var DefaultDashboardTabIds = /* @__PURE__ */ ((DefaultDashboardTabIds2) => {
  DefaultDashboardTabIds2["LEADS"] = "Leads";
  DefaultDashboardTabIds2["APPLIED"] = "Applied";
  DefaultDashboardTabIds2["DRAFT_OFFERS"] = "Draft";
  DefaultDashboardTabIds2["CONDITIONAL"] = "Conditional";
  DefaultDashboardTabIds2["UNCONDITIONAL"] = "Unconditional";
  DefaultDashboardTabIds2["COMPLETED"] = "Completed";
  DefaultDashboardTabIds2["CLOSED"] = "Closed";
  return DefaultDashboardTabIds2;
})(DefaultDashboardTabIds || {});
var applyUniConfig = {
  // TODO: Where and how do we define which variables are available to these "templates"?
  offerLetterStartTemplate: `We are delighted to issue you {conditionTypeWithArticle} offer to study {courseName} starting {intakeIdLabel}.`,
  offerLetterEndTemplate: `Admissions Team`,
  scholarships: [],
  termsAndConditionsUrl: "https://www.enroly.com",
  privacyPolicyUrl: "https://www.enroly.com",
  privacyPolicyConsentWording: {
    subtitle: "Our privacy policy and how it affects you",
    header: "I consent to the processing of sensitive data (e.g., health, ethnicity) to support my application and for monitoring purposes",
    buttonLabel: "Privacy policy",
    bodyText: "The information provided will be used to assess your eligibility and progress your application, in accordance with the {universityName} {privacyPolicyUrl}"
  },
  termsAndConditionConsentWording: {
    subtitle: "Read and consent to the University's terms and conditions",
    header: "Terms & conditions",
    buttonLabel: "Terms & conditions",
    bodyText: "I consent to the {universityName}"
  },
  welcomeScreen: {
    title: "Begin your application",
    content: `Using this app you will be able to complete your application for undergraduate and postgraduate courses at the university.

In this process you will be asked a series of questions and given a recommended set of documents to be uploaded in advance of your application to a course or programme offered by the university.

The list of documents and guidelines provided in this process do not constitute legal advice. The purpose is to speed up your application process.

We recommend that you have a photo or scan of your academic certificate or transcript as this information is used as part of your application, but you can get started without them.`
  },
  rejectionReasons: {
    entryCriteriaNotMet: "",
    failedAcademicAssessment: "",
    failedCredibilityAssessment: "",
    fraudulentApplication: "",
    courseClosure: "",
    courseFull: "",
    unableToOfferCourse: "",
    deadlineHasPassed: "",
    closedByApplicant: "",
    wrongApplicationForm: "",
    failedPreCasInterview: "",
    failedComplianceInterview: "",
    negativeQualificationVerification: "",
    duplicateApplication: "",
    inactiveApplication: "",
    regionExclusiveToAgent: "",
    other: ""
  }
  // New configuration flags with default values (all fields visible by default) (commented intentionally)
  // disableFundingTuitionFeeQuestion: false,
  // disableFundingMaintenanceQuestion: false,
  // disableFundingWorkQuestion: false,
  // disableDeclarationTask: false,
  // disableDeclarationInterruptionQuestion: false,
  // disableDeclarationConvictionQuestion: false
};
var defaultApplyUniConfig = deepFreeze(applyUniConfig);

// src/apply-config-applicationTasks.ts
function deepFreeze2(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze2(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var applicationTaskConfig = {
  EnglishLanguage: {
    default: true
  },
  Employment: {
    default: true
  },
  References: {
    default: true
  },
  PersonalStatement: {
    default: true
  },
  ResearchProposal: {
    default: false
  },
  Funding: {
    default: true
  },
  ImmigrationHistory: {
    default: true
  },
  DiversityInclusion: {
    default: true
  },
  Representation: {
    default: true
  },
  Referral: {
    default: true
  },
  Declarations: {
    default: true
  }
};
var defaultApplicationTaskConfig = deepFreeze2(applicationTaskConfig);

// src/apply-config-dashboardTabs.ts
import { ApplicantOfferStatus as ApplicantOfferStatus2, ApplicationStatus as ApplicationStatus2, ApplyDocTypes } from "platform-types";
var standardTabs = Object.freeze({
  ["Pipeline"]: [
    { label: "Leads", id: "Leads" /* LEADS */ },
    { label: "Applied", id: "Applied" /* APPLIED */ },
    { label: "Conditional", id: "Conditional" /* CONDITIONAL */ },
    { label: "Unconditional", id: "Unconditional" /* UNCONDITIONAL */ }
  ],
  ["Outcome"]: [
    { label: "Completed", id: "Completed" /* COMPLETED */ },
    { label: "Closed", id: "Closed" /* CLOSED */ }
  ]
});
var agentTabs = Object.freeze({
  ["Pipeline"]: [
    { label: "Leads", id: "Leads" /* LEADS */ },
    { label: "Applied", id: "Applied" /* APPLIED */ },
    { label: "Conditional", id: "Conditional" /* CONDITIONAL */ },
    { label: "Unconditional", id: "Unconditional" /* UNCONDITIONAL */ }
  ],
  ["Outcome"]: [
    { label: "Completed", id: "Completed" /* COMPLETED */ },
    { label: "Closed", id: "Closed" /* CLOSED */ }
  ]
});
var TabIdDocumentMap = Object.freeze({
  ["Leads" /* LEADS */]: [ApplyDocTypes.ApplicationSummary],
  ["Applied" /* APPLIED */]: [ApplyDocTypes.OfferSummary],
  ["Conditional" /* CONDITIONAL */]: [ApplyDocTypes.OfferSummary],
  ["Unconditional" /* UNCONDITIONAL */]: [ApplyDocTypes.OfferSummary],
  ["Completed" /* COMPLETED */]: [ApplyDocTypes.OfferSummary],
  ["Closed" /* CLOSED */]: [ApplyDocTypes.OfferSummary, ApplyDocTypes.ApplicationSummary]
});
var TabIdStageMap = Object.freeze({
  ["Leads" /* LEADS */]: {
    applicationStatuses: [ApplicationStatus2.InProgress, ApplicationStatus2.Completed],
    offerStatuses: []
  },
  ["Applied" /* APPLIED */]: {
    offerStatuses: [ApplicantOfferStatus2.Applied],
    applicationStatuses: []
  },
  ["Conditional" /* CONDITIONAL */]: { offerStatuses: [ApplicantOfferStatus2.Conditional], applicationStatuses: [] },
  ["Unconditional" /* UNCONDITIONAL */]: {
    offerStatuses: [ApplicantOfferStatus2.Unconditional],
    applicationStatuses: []
  },
  ["Completed" /* COMPLETED */]: { offerStatuses: [ApplicantOfferStatus2.Completed], applicationStatuses: [] },
  ["Closed" /* CLOSED */]: {
    offerStatuses: [ApplicantOfferStatus2.Rejected, ApplicantOfferStatus2.Withdrawn],
    applicationStatuses: [ApplicationStatus2.Rejected, ApplicationStatus2.Withdrawn]
  }
});
var TabIdStageMapForAgent = Object.freeze({
  ["Leads" /* LEADS */]: {
    applicationStatuses: [ApplicationStatus2.InProgress, ApplicationStatus2.Completed],
    offerStatuses: []
  },
  ["Applied" /* APPLIED */]: {
    offerStatuses: [ApplicantOfferStatus2.Applied],
    applicationStatuses: []
  },
  ["Conditional" /* CONDITIONAL */]: { offerStatuses: [ApplicantOfferStatus2.Conditional], applicationStatuses: [] },
  ["Unconditional" /* UNCONDITIONAL */]: {
    offerStatuses: [ApplicantOfferStatus2.Unconditional],
    applicationStatuses: []
  },
  ["Completed" /* COMPLETED */]: { offerStatuses: [ApplicantOfferStatus2.Completed], applicationStatuses: [] },
  ["Closed" /* CLOSED */]: {
    offerStatuses: [ApplicantOfferStatus2.Rejected, ApplicantOfferStatus2.Withdrawn],
    applicationStatuses: [ApplicationStatus2.Rejected, ApplicationStatus2.Withdrawn]
  }
});
var dashboardTabs = Object.freeze({
  "[UniAdmin]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Uni]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[UniLite]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[UniSecure]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Admin]": { tabs: standardTabs, map: TabIdStageMap, documentMap: TabIdDocumentMap },
  "[Agent]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap },
  "[AgencyAdmin]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap },
  "[Partner]": { tabs: agentTabs, map: TabIdStageMapForAgent, documentMap: TabIdDocumentMap }
});

// src/apply-config-uniRequirements.ts
import { ApplicantOfferRequirementTask, ApplicantOfferRequirementTaskLevel, OfferTaskLabel as OfferTaskLabel2, UniConfigRequirementTaskFulfilmentMethod } from "platform-types";
function deepFreeze3(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze3(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var applyUniCRequirements = [
  {
    id: ApplicantOfferRequirementTask.Passport,
    enabled: true,
    type: ApplicantOfferRequirementTask.Passport,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Passport,
    label: OfferTaskLabel2.Passport,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a copy of your passport"
    }
  },
  {
    id: ApplicantOfferRequirementTask.PhotoID,
    enabled: true,
    type: ApplicantOfferRequirementTask.PhotoID,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.PhotoID,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload your photographic proof of identity.  For example, this could be your Passport or National Identity Card."
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.AcademicResults,
    label: OfferTaskLabel2.AcademicResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: `Your offer is subject to meeting the academic entry requirement of {${ApplicantOfferRequirementTask.AcademicResults}}.`
    }
  },
  {
    id: ApplicantOfferRequirementTask.FinalAcademicResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.FinalAcademicResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.FinalAcademicResults,
    label: OfferTaskLabel2.FinalAcademicResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Off,
    conditions: {
      default: "You previously specified you did not have final results yet for your study. Please complete this task when you have your final results."
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicCertificate,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicCertificate,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.AcademicCertificate,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Upload of academic certificate proving grades, if not in English, also upload the certified English translation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.AcademicTranscript,
    enabled: true,
    type: ApplicantOfferRequirementTask.AcademicTranscript,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.AcademicTranscript,
    label: OfferTaskLabel2.AcademicTranscript,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Upload of academic transcript proving grades, if not in English, also upload the certified English translation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.EnglishLanguageResults,
    enabled: true,
    type: ApplicantOfferRequirementTask.EnglishLanguageResults,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.EnglishLanguageResults,
    label: OfferTaskLabel2.EnglishLanguageResults,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: `Your offer is subject to meeting the English language requirement of {${ApplicantOfferRequirementTask.EnglishLanguageResults}}.`
    }
  },
  {
    id: ApplicantOfferRequirementTask.EnglishLanguageCertificate,
    enabled: true,
    type: ApplicantOfferRequirementTask.EnglishLanguageCertificate,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.EnglishLanguageCertificate,
    label: OfferTaskLabel2.EnglishLanguageCertificate,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload your English Language Qualification or test results."
    }
  },
  {
    id: ApplicantOfferRequirementTask.CV,
    enabled: true,
    type: ApplicantOfferRequirementTask.CV,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.CV,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a current up to date CV to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfManagerialExperience,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfManagerialExperience,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.ProofOfManagerialExperience,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your managerial experience"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfAddress,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfAddress,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.ProofOfAddress,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your current address"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfImmigrationStatus,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfImmigrationStatus,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.ProofOfImmigrationStatus,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload proof of your UK immigration status"
    }
  },
  {
    id: ApplicantOfferRequirementTask.LetterOfRecommendation,
    enabled: true,
    type: ApplicantOfferRequirementTask.LetterOfRecommendation,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.LetterOfRecommendation,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a letter of recommendation"
    }
  },
  {
    id: ApplicantOfferRequirementTask.PersonalStatement,
    enabled: true,
    type: ApplicantOfferRequirementTask.PersonalStatement,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.PersonalStatement,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a personal statement to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.Portfolio,
    enabled: false,
    type: ApplicantOfferRequirementTask.Portfolio,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.Portfolio,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a portfolio to support your application"
    }
  },
  {
    id: ApplicantOfferRequirementTask.ProofOfNameChange,
    enabled: true,
    type: ApplicantOfferRequirementTask.ProofOfNameChange,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.ProofOfNameChange,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload evidence of the official document that confirm your change of name."
    }
  },
  {
    id: ApplicantOfferRequirementTask.NameAffidavit,
    enabled: true,
    type: ApplicantOfferRequirementTask.NameAffidavit,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.NameAffidavit,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a name affidavit confirming your name change"
    }
  },
  {
    id: ApplicantOfferRequirementTask.BirthCert,
    enabled: true,
    type: ApplicantOfferRequirementTask.BirthCert,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.BirthCert,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please provide a birth or adoption certificate."
    }
  },
  {
    id: ApplicantOfferRequirementTask.ResearchProposal,
    enabled: false,
    type: ApplicantOfferRequirementTask.ResearchProposal,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.Upload,
    label: OfferTaskLabel2.ResearchProposal,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please upload a research proposal to support your application."
    }
  },
  {
    id: ApplicantOfferRequirementTask.RefereeDetails,
    enabled: true,
    type: ApplicantOfferRequirementTask.RefereeDetails,
    fulfilmentMethod: UniConfigRequirementTaskFulfilmentMethod.RefereeDetails,
    label: OfferTaskLabel2.RefereeDetails,
    defaultLevel: ApplicantOfferRequirementTaskLevel.Condition,
    conditions: {
      default: "Please provide the details of your referee, from whom we can request a reference."
    }
  }
];
var defaultApplyUniConfigRequirement = deepFreeze3(applyUniCRequirements);

// src/apply-applicationStages.ts
import { ApplicationStatus as ApplicationStatus3 } from "platform-types";
var applicationStatusLabels = {
  [ApplicationStatus3.InProgress]: { id: ApplicationStatus3.InProgress, label: "In Progress" },
  [ApplicationStatus3.Submitted]: { id: ApplicationStatus3.Submitted, label: "Submitted" },
  [ApplicationStatus3.AwaitingDecision]: { id: ApplicationStatus3.AwaitingDecision, label: "Awaiting Decision" },
  [ApplicationStatus3.Offered]: { id: ApplicationStatus3.Offered, label: "Offered" },
  [ApplicationStatus3.Rejected]: { id: ApplicationStatus3.Rejected, label: "Rejected" },
  [ApplicationStatus3.Cancelled]: { id: ApplicationStatus3.Cancelled, label: "Cancelled" },
  [ApplicationStatus3.Withdrawn]: { id: ApplicationStatus3.Withdrawn, label: "Withdrawn" }
};

// src/english-test-data.ts
import { EnglishTestNotReqdReason, EnglishTestType, GradeLevel, GradeSystem } from "platform-types";
function deepFreeze4(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze4(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var ENGLISH_TEST_TYPE_VAL_LABEL_MAP = deepFreeze4({
  IELTS_FOR_UKVI: "IELTS for UKVI",
  IELTS_ACADEMIC: "IELTS Academic",
  IELTS: "IELTS General",
  ESOL_SELT: "LanguageCert International ESOL SELT",
  ISE: "Trinity College London Integrated Skills in English (ISE)",
  PTE_UKVI: "PTE Academic UKVI",
  PTE: "PTE Academic",
  PSI: "PSI Services Skills for English UKVI",
  Cambridge: "Cambridge Assessment English test",
  TOEFL: "TOEFL",
  ELLT: "OI Digital Institute English Language Level Test (ELLT)",
  UNI: `University's English test`
});
var NOT_REQUIRED_REASONS = deepFreeze4(
  Object.entries(EnglishTestNotReqdReason).map(([value, label]) => ({
    label,
    value
  }))
);
var ENGLISH_TEST_TYPES = deepFreeze4(
  Object.entries(EnglishTestType).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATIONS = deepFreeze4(
  Object.entries(GradeLevel).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATION_GRADE_SYSTEMS = deepFreeze4(
  Object.entries(GradeSystem).map(([value, label]) => ({
    label,
    value
  }))
);
var QUALIFICATION_VAL_LABEL_MAP = deepFreeze4(
  Object.entries(GradeLevel).reduce(
    (map, [key, value]) => {
      map[key] = value;
      return map;
    },
    {}
  )
);
var ENGLISH_SPEAKING_COUNTRIES = deepFreeze4([
  "Antiguans",
  "Australian",
  "Bahamian",
  "Barbadian",
  "Belizean",
  "Anguillan",
  "Bermudan",
  "British (IOT)",
  "Virgin Islander (British)",
  "Caymanian",
  "Falkland Islander",
  "Gibraltarian",
  "Montserratian",
  "Pitcairn Islander",
  "Saint Helenian",
  "South Georgia and the South Sandwich Islands",
  "Turks and Caicos Islander",
  "Canadian",
  "Dominican",
  "Grenadian",
  "Guyanese",
  "Jamaican",
  "Maltese",
  "New Zealander",
  "Kittian",
  "Saint Lucian",
  "Saint Vincentian",
  "Trinidadian",
  "American"
]);

// src/highest-qualification.ts
function deepFreeze5(obj) {
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === "object" && obj[prop] !== null && !Object.isFrozen(obj[prop])) {
      deepFreeze5(obj[prop]);
    }
  });
  return Object.freeze(obj);
}
var HIGHEST_QUALIFICATIONS = deepFreeze5([
  { value: "99999", label: "Not available" },
  { value: "C0000", label: "Certificate of Higher Education (CertHE)" },
  { value: "C0001", label: "Higher National Certificate (HNC)" },
  { value: "C0004", label: "National Vocational Qualification (NVQ) at level C" },
  { value: "C0007", label: "Other qualification at level C" },
  { value: "C0008", label: "Credits at level C" },
  { value: "C0010", label: "Higher Apprenticeship (level 4)" },
  { value: "D0000", label: "UK doctorate degree" },
  { value: "D0001", label: "Non-UK doctorate degree" },
  { value: "D0002", label: "Other qualification at level D" },
  { value: "H0000", label: "UK first degree with honours" },
  { value: "H0001", label: "Non-UK first degree" },
  {
    value: "H0002",
    label: "First degree with honours leading to Qualified Teacher Status (QTS)/registration with a General Teaching Council (GTC)"
  },
  { value: "H0013", label: "Professional Graduate Certificate in Education" },
  { value: "H0016", label: "Other qualification at level H" },
  { value: "I0000", label: "UK ordinary (non-honours) first degree" },
  { value: "J0000", label: "Foundation degree" },
  { value: "J0002", label: "Diploma of Higher Education (DipHE)" },
  { value: "J0003", label: "Higher National Diploma (HND)" },
  { value: "J0007", label: "Scottish Vocational Qualification (SVQ) 4" },
  { value: "J0008", label: "Certificate in Education (CertEd) or Diploma in Education (DipEd)" },
  { value: "J0009", label: "Foundation course at level J" },
  { value: "J0010", label: "Other qualification at level J" },
  { value: "M0000", label: "UK masters degree" },
  { value: "M0001", label: "Non-UK masters degree" },
  {
    value: "M0002",
    label: "Integrated undergraduate/postgraduate taught masters degree on the enhanced/extended pattern"
  },
  { value: "M0009", label: "Diploma at level M" },
  { value: "M0012", label: "Certificate at level M" },
  {
    value: "M0016",
    label: "Postgraduate Certificate in Education or Professional Graduate Diploma in Education"
  },
  { value: "M0021", label: "Other taught qualification at level M" },
  { value: "M0022", label: "Credits at level M" },
  { value: "P0000", label: "Diploma at level 3" },
  { value: "P0001", label: "Certificate at level 3" },
  { value: "P0002", label: "Award at level 3" },
  { value: "P0003", label: "AQA Baccalaureate (Bacc)" },
  { value: "P0004", label: "A/AS level" },
  { value: "P0005", label: "14-19 Advanced Diploma (level 3)" },
  { value: "P0006", label: "Scottish Baccalaureate" },
  { value: "P0007", label: "Scottish Highers/Advanced Highers" },
  { value: "P0008", label: "International Baccalaureate (IB) Diploma" },
  { value: "P0009", label: "International Baccalaureate (IB) Certificate" },
  { value: "P0010", label: "Cambridge Pre-U Diploma" },
  { value: "P0011", label: "Cambridge Pre-U Certificate" },
  { value: "P0012", label: "Welsh Baccalaureate Advanced Diploma (level 3)" },
  { value: "P0013", label: "Other qualification at level 3" },
  { value: "P0014", label: "UK Level 3 qualifications of which none are subject to UCAS Tariff" },
  { value: "P0015", label: "UK Level 3 qualifications of which all are subject to UCAS Tariff" },
  {
    value: "P0016",
    label: "Level 3 qualifications of which some are UK qualifications subject to UCAS Tariff"
  },
  { value: "P0017", label: "T levels" },
  { value: "Q0000", label: "14-19 Higher Diploma (level 2)" },
  { value: "Q0001", label: "Welsh Baccalaureate Intermediate Diploma (level 2)" },
  { value: "Q0002", label: "Other qualification at level 2" },
  { value: "R0000", label: "14-19 Foundation Diploma (level 1)" },
  { value: "R0001", label: "Welsh Baccalaureate Foundation Diploma (level 1)" },
  { value: "R0002", label: "Other qualification at level 1" },
  { value: "X0000", label: "Higher education (HE) access course, Quality Assurance Agency (QAA) recognised" },
  {
    value: "X0001",
    label: "Higher education (HE) access course, not Quality Assurance Agency (QAA) recognised"
  },
  { value: "X0002", label: "Mature student admitted on basis of previous experience and/or admissions test" },
  { value: "X0003", label: "Other qualification level not known" },
  { value: "X0004", label: "Student has no formal qualification" }
]);
var HIGHEST_QUALIFICATIONS_LIST = deepFreeze5(
  HIGHEST_QUALIFICATIONS.map((qualification) => ({
    label: `${qualification.value} - ${qualification.label}`,
    value: qualification.value
  }))
);
var HIGHEST_QUALIFICATIONS_MAP = deepFreeze5(
  HIGHEST_QUALIFICATIONS.reduce(
    (map, qualification) => {
      map[qualification.value] = qualification.label;
      return map;
    },
    {}
  )
);
export {
  ActiveApplicationStatues,
  DefaultDashboardTabIds,
  ENGLISH_SPEAKING_COUNTRIES,
  ENGLISH_TEST_TYPES,
  ENGLISH_TEST_TYPE_VAL_LABEL_MAP,
  HIGHEST_QUALIFICATIONS,
  HIGHEST_QUALIFICATIONS_LIST,
  HIGHEST_QUALIFICATIONS_MAP,
  MONTHS,
  NOT_REQUIRED_REASONS,
  OfferTooltipLabels,
  QUALIFICATIONS,
  QUALIFICATION_GRADE_SYSTEMS,
  QUALIFICATION_VAL_LABEL_MAP,
  TabIdDocumentMap,
  TabIdStageMap,
  TabIdStageMapForAgent,
  applicantTasksConfig,
  applicationStatusLabels,
  dashboardTabs,
  defaultApplicationTaskConfig,
  defaultApplyUniConfig,
  defaultApplyUniConfigRequirement,
  offerIssueStatuses,
  offerNeedsReissueStatuses,
  statusReasonOptions,
  systemGeneratedApplicantStatusReasonLabels,
  uniViewApplicantTaskGroups,
  userGeneratedApplicantStatusReasonLabels
};
